const INITIAL_VALUE = {
    cpf: '',
    submissoes: []
}

export default function(state = INITIAL_VALUE, action) {

    switch (action.type) {
        case 'FIND_SUBSCRIPTION':
            return { ...state, cpf: action.payload }
        case 'SET_SUBSCRIPTIONS':
            return { ...state, submissoes: action.payload }    
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/view/inicio/acoes/MySubscriptionsReducers.js